import * as zod from 'zod';

export const NotificationKind = zod.enum([
  'waitForConfirmation',
  'robotFailure',
  'externalControl',
  'toast',
  'captureStorage',
]);

export type NotificationKind = zod.infer<typeof NotificationKind>;

export const NotificationStatus = zod.enum(['dismissed', 'viewed', 'archived']);

export type NotificationStatus = zod.infer<typeof NotificationStatus>;

/**
 * How close one skill's capture directory is to its size bound.
 *
 * `warning` is sent while there is still room, so an operator has the chance to
 * copy records off the robot before anything is deleted. `rotating` says the
 * deleting has started, which is a different message and not one to bury in the
 * same line.
 */
export const CaptureStorageLevel = zod.enum([
  'warning',
  'rotating',
  'diskFloor',
]);

export type CaptureStorageLevel = zod.infer<typeof CaptureStorageLevel>;

export const NotificationData = zod.object({
  id: zod.string(),
  createdAt: zod.string(),
  statusByUserID: zod.record(NotificationStatus).optional(),
  kind: NotificationKind,
  robotID: zod.string(),
  robotName: zod.string().optional(),
  routineID: zod.string().optional(),
  stepID: zod.string().optional(),
  failureReason: zod.string().optional(),
  failureKind: zod.string().optional(),
  failureTraceID: zod.string().optional(),

  // `captureStorage` only. The skill and routine together name the directory,
  // because a skill used by two routines has one directory per routine and
  // only one of them may be full.
  skillID: zod.string().optional(),
  skillName: zod.string().optional(),
  storageLevel: CaptureStorageLevel.optional(),
  storageUsedBytes: zod.number().optional(),
  storageLimitBytes: zod.number().optional(),
});

export type NotificationData = zod.infer<typeof NotificationData>;
